
export default function WeAreSecure() {

    return (
        <span className="sidebar-component" style={{ display: 'table', flexDirection: 'column' }}>
            <p className="sidebar-header">We are secure</p>
            <p>
                <img className="we-are-secure-logo" src={require('../../../assets/weAreSecure/u64_1_sectigo.png')} alt="sectigo-logo" />
                <img className="we-are-secure-logo" src={require('../../../assets/weAreSecure/u65_1_secure.png')} alt="sectigo-logo" />
            </p>
            
        </span>
    )

}


